import { render, staticRenderFns } from "./fishery-bureau.vue?vue&type=template&id=4c24c6bc&scoped=true&"
import script from "./fishery-bureau.vue?vue&type=script&lang=js&"
export * from "./fishery-bureau.vue?vue&type=script&lang=js&"
import style0 from "./fishery-bureau.vue?vue&type=style&index=0&id=4c24c6bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24c6bc",
  null
  
)

export default component.exports